import React from 'react';
import { Link } from 'react-router-dom';

const getPoliglotLink = (link, blank, local, text, className, children) => {
  console.log(text, local);
  if (!local) {
    return (
      <a href={link} target={blank ? '_blank' : '_self'} className={className}>
        {text}
        {children}
      </a>
    );
  } else {
    return (
      <Link to={link} className={className}>
        {text}
        {children}
      </Link>
    );
  }
};

export default function PoliglotLink({ link, blank, local, text, className, children }) {
  return getPoliglotLink(link, blank, local, text, className, children);
}
